<template>
    <div id="app">
        <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />-->
        <keep-alive :include="keepAlive">
            <router-view />
        </keep-alive>
    </div>
</template>

<style lang="scss">
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    background-color: #f5f5f5;
    height: 100%;
    color: #666666;
    overflow: scroll;
    border-top: 1px solid #f5f5f5;
}
</style>
<script type='text/javascript'>
export default {
    data() {
        return {};
    },
    computed: {
        keepAlive() {
            return this.$store.state.keepAlive;
        },
    },
    created() {
        this.$global.url = window.location.href;
    },
};
</script>
